import {Injectable} from '@angular/core';
import {Store, StoreConfig} from '@datorama/akita';

export interface UiState {
  key: string;
  httpLoading: boolean;
  loadingBtn: string;
  errorMessage: UiMessage;
  infoMessage: UiMessage;
  updated: Date;
}

export interface UiMessage {
  message: string;
  timestamp: Date;
}

export function createInitialState(): UiState {
  return {
    key: '',
    httpLoading: false,
    loadingBtn: null,
    errorMessage: null,
    infoMessage: null,
    updated: new Date(),
  };
}

@Injectable({providedIn: 'root'})
@StoreConfig({name: 'ui'})
export class UiStore extends Store<UiState> {

  constructor() {
    super(createInitialState());
  }

}

